import React, { Suspense, useContext, useState } from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse"; // Assuming this is a layout component
import FullLoader from "components/loader/full-loader";
import { useDeleteData, useFetchData } from "hooks/useApiHooks";
import { AppContext } from "contexts/AppContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import { buildQueryString } from "utils/queryHelpers";
import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";

// Metric Card Component (used for displaying summary data like total payments, total orders)
const MetricCard = ({ title, value, currency, comparison }) => {
  return (
    <table className="table">
      <tbody>
        <tr>
          <td className="text-muted ">{title}</td>
          <td className=" text-end">
            {currency ? `IDR ${value.toLocaleString()}` : value}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

// Report Card Component (used to display summary metrics)
const ReportCard = ({ totalData, totalPembayaran }) => {
  const reportData = [
    {
      title: "Total Data",
      value: totalData,
      currency: false, // No currency for this value
    },
    {
      title: "Total Pembayaran",
      value: totalPembayaran,
      currency: true, // IDR
    },
  ];

  return (
    <div className="row justify-content-center mb-3">
      <div className=" col-12 mb-3">
        <div
          className="shadow-sm card-metric card d-flex flex-column"
          style={{
            borderRadius: "10px",
            border: "none",
            height: "100%", // Ensure the card takes full height of the container
          }}
        >
          <div className="card-header ">
            <h2 className="m-0">Total Data</h2>
          </div>
          {reportData.map((data, index) => (
            <MetricCard
              key={index}
              title={data.title}
              value={data.value}
              currency={data.currency}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// Table Component (Updated for displaying orders)
const OrderTable = ({ orders, handleDelete }) => {
  return (
    <div className="table-responsive">
      <table className="table table-hover table-vcenter">
        <thead>
          <tr>
            <th>Order #</th>
            <th>Pelanggan</th>
            <th>Jumlah Tamu</th>
            <th>Nama Agen</th>
            <th>Tanggal Pemesanan</th>
            <th>Sesi</th>
            <th>Total Penjualan</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order, index) => (
            <tr key={index}>
              <td>{order.orderNumber}</td>
              <td>{order.customerName}</td>
              <td>{order.guestCount}</td>
              <td>{order.agentName}</td>
              <td>{order.orderDate}</td>
              <td>{order.session}</td>
              <td>IDR {order.totalSales.toLocaleString()}</td>
              <td>{order.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Main Page Component (Laporan Produk)
const LaporanPembayaran = () => {
  const [search, setSearch] = useState(""); // For search input
  const [currentPage, setCurrentPage] = useState(1); // For pagination
  const [orders, setOrders] = useState([
    {
      orderNumber: "24120010",
      customerName: "Komang Gede",
      guestCount: 5,
      agentName: "John Doe",
      orderDate: "2024-12-13",
      session: "Sesi 5",
      totalSales: 1000000,
      status: "Completed",
    },
    {
      orderNumber: "24120009",
      customerName: "Komang Gede",
      guestCount: 3,
      agentName: "Jane Smith",
      orderDate: "2024-12-13",
      session: "Sesi 5",
      totalSales: 500000,
      status: "Pending",
    },
    // Add more order data here
  ]); // Replace with real data from an API or state management

  // Handling search functionality
  const filteredOrders = orders.filter(
    (order) =>
      order.orderNumber.includes(search) ||
      order.customerName.toLowerCase().includes(search.toLowerCase())
  );

  // Pagination logic
  const totalPages = Math.ceil(filteredOrders.length / LIMIT_DATA_PER_PAGE);

  const Pagination = usePaginationWithComponent({
    totalPages,
    currentPage,
    onPageChange: setCurrentPage,
    visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  });

  // Handle delete operation
  const handleDelete = (e, id) => {
    e.stopPropagation();
    // Handle deletion logic
  };

  // Handling the search input on keypress
  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-5">
        {/* Report Card */}
      <h1>Laporan Pembayaran</h1>

        <ReportCard
          totalData={filteredOrders.length}
          totalPembayaran={filteredOrders.reduce(
            (total, order) => total + order.totalSales,
            0
          )}
        />

        {/* Search and Orders Table */}
        <div className="table-container vh-100">
          <div className="search-container mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Cari Order # atau Pelanggan..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={handleSearch}
            />
          </div>

          {/* Orders Table */}
          <OrderTable orders={filteredOrders} handleDelete={handleDelete} />

          {/* Pagination */}
          <div className="mt-4">{Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default LaporanPembayaran;
